import React from 'react';

import { IconChevronRight, Spacer, Tag } from '@zillow/constellation';
import { LoadingParagraph } from '@zg-rentals/loading-components';
import type { CardProps } from '@zillow/constellation';

import { StyledCard, StyledChildContentContainer, StyledIconContainer } from './StyledComponents';

type Props = {
  cardType?: string;
  tagSize?: string;
  tagStatus?: string;
  tagAppearance?: string;
  bodyHeading?: string;
  body?: string | React.ReactElement;
  withChevron?: boolean;
  children?: Array<React.ReactNode> | React.ReactElement;
  cursor?: string;
  onClick?: (event: React.SyntheticEvent) => void;
  isLoading?: boolean;
};

const SimpleCard = ({
  body,
  bodyHeading,
  cardType = 'secondary',
  children,
  cursor = 'default',
  onClick,
  tagStatus,
  tagSize = 'sm',
  tagAppearance = 'gray',
  withChevron = false,
  isLoading = false,
  ...rest
}: Props | typeof CardProps) => {
  const handleClick = (event: React.SyntheticEvent) => {
    if (onClick) {
      onClick(event);
    }
  };

  return (
    <StyledCard
      data-testid="SimpleCard"
      cardType={cardType}
      cardElevation={0}
      onClick={handleClick}
      cursor={cursor}
      isDisabled={isLoading}
      {...rest}
    >
      <StyledChildContentContainer withChevron={withChevron}>
        {children ? (
          children
        ) : (
          <>
            {tagStatus && (
              <Spacer data-testid="SimpleCard-Status" marginBottom="xs">
                <Tag size={tagSize} appearance={tagAppearance} marginRight="xs">
                  {tagStatus}
                </Tag>
              </Spacer>
            )}

            <LoadingParagraph
              data-testid="SimpleCard-Heading"
              textStyle="body-sm-bold"
              isLoading={isLoading}
              loadingWidth="100%"
              css={{ fontSize: { lg: 'body' } }}
            >
              {bodyHeading}
            </LoadingParagraph>

            <LoadingParagraph
              data-testid="SimpleCard-Body"
              textStyle="body-sm"
              isLoading={isLoading}
              loadingWidth="75%"
            >
              {body}
            </LoadingParagraph>
          </>
        )}
      </StyledChildContentContainer>

      {withChevron && (
        <StyledIconContainer>
          <IconChevronRight />
        </StyledIconContainer>
      )}
    </StyledCard>
  );
};

export default SimpleCard;
